import { Box } from "@mui/material"

import InProcessContent from "./InProcessContent"

import { OutputContainerStyles } from "./styles/OutputStyles"

function InProcess() {

    return (
        <>
            <Box sx={OutputContainerStyles}>
                <InProcessContent />
            </Box>
        </>
    )
}

export default InProcess
